<template>
  <c-modal type="negative" max-width="860px">
    <preview-sync-schedules />
  </c-modal>
</template>

<script setup>
import PreviewSyncSchedules from "components/meeting/PreviewSyncSchedules.vue";
</script>
